/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import React from "react"

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M18.125 3.125H1.875a.624.624 0 00-.625.625v12.5c0 .346.28.625.625.625h16.25c.346 0 .625-.28.625-.625V3.75a.624.624 0 00-.625-.625zm-.781 2.164v10.18H2.656V5.289l-.539-.42.768-.986.836.65h12.56l.836-.65.768.986-.541.42zm-1.063-.758L10 9.414 3.719 4.531l-.836-.65-.768.986.54.42 6.671 5.188a1.093 1.093 0 001.342 0l6.676-5.186.539-.42-.768-.986-.834.648z"
      fill="currentColor"
    />
  </svg>
)
